import React from 'react';

const AboutDaim = () => {
    return (
        <div className="row mt-5 mb-5">
            <div className="col-md-6">
                <h3 data-aos="fade-up" data-aos-duration="1000">
                    <span style={{ color: '#ff3465' }}>Diam, in tempor</span> tempor mauris. Tortor tortor, vitae nunc, morbi facilisis ornare diam, amet.
                </h3>
                <p data-aos="fade-up" data-aos-duration="2000" style={{ textAlign: 'justify' }}>
                    Consectetur facilisis euismod non porttitor diam vel. Aenean amet non fermentum sem enim sem ut. Diam mattis enim habitant sit vehicula cursus urna porttitor consequat. Egestas et vestibulum, a vel. Feugiat phasellus gravida lobortis vel. Pulvinar fringilla scelerisque et lorem a lectus tortor, at. Sociis nunc sit et urna, nam eu venenatis mattis commodo.
                </p>
                <p data-aos="fade-up" data-aos-duration="3000" style={{ textAlign: 'justify' }}>
                    Orci, ornare feugiat neque elit scelerisque pharetra. Egestas hendrerit faucibus nisl consectetur odio ac vel viverra. Aliquam nulla pretium cursus leo at ornare habitasse nam nam.
                </p>
            </div>
            <div className="col-md-6">
                <p data-aos="fade-up" data-aos-duration="1000" style={{ textAlign: 'justify' }}>
                    Egestas hendrerit faucibus nisl consectetur odio ac vel viverra. Aliquam nulla pretium cursus leo at ornare habitasse nam nam.
                </p>
                <p data-aos="fade-up" data-aos-duration="2000" style={{ textAlign: 'justify' }}>
                    Egestas et vestibulum, a vel. Feugiat phasellus gravida lobortis vel. Pulvinar fringilla scelerisque et lorem a lectus tortor, at. Sociis nunc sit et urna, nam eu venenatis mattis commodo. Sodales quam lobortis in vel. Et, et bibendum quam in pretium urna, faucibus. Pharetra, et imperdiet massa nunc auctor ut. Egestas dignissim nisi, ornare habitasse. Orci.
                </p>
                <p data-aos="fade-up" data-aos-duration="3000" style={{ textAlign: 'justify' }}>
                    Orci, ornare feugiat neque elit scelerisque pharetra. Egestas hendrerit faucibus nisl consectetur odio ac vel viverra. Aliquam nulla pretium cursus leo at ornare habitasse nam nam. Pharetra, et imperdiet massa nunc auctor ut. Egestas dignissim nisi, ornare habitasse. Orci.
                </p>
            </div>
        </div>
    );
};

export default AboutDaim;